import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

declare module 'i18next' {
	interface CustomTypeOptions {
		returnNull: false;
	}
}

if (localStorage.getItem('i18nextLng') !== 'he' && localStorage.getItem('i18nextLng') !== 'en') {
	localStorage.setItem('i18nextLng', 'he');
}

i18n.use(HttpApi)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng: 'he',
		fallbackLng: 'he',
		load: 'languageOnly',
		returnNull: false,
		supportedLngs: ['he', 'en'],
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: (lng: string, ns: string) => {
				return `/wp-content/themes/hello-theme-child-master/public/locales/${lng}/${ns}.json`;
			},
		},
		initImmediate: false,
	} as any, (_err, _t) => {
		if (_err) {
			console.log(_err);
		}
	})
	.then(() => {
		if (!i18n.language) {
			i18n.changeLanguage('he');
		}
	});

export default i18n;
